var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { z } from 'zod';
import axios from 'axios';
import Cookies from 'js-cookie';
import API from 'utils/WebAPIUtils';
import { ActionTypes, PickerTypes, NotificationStatusMap, UploadTypes } from 'constants/AdminConstants';
import { FormStateSchema } from 'types/formState';
import { subscribeToActivateAppChannel } from 'services/pusher';
import CompanyStore from 'stores/CompanyStore/store';
import { ClientKeySchema } from 'types/actions/clientStateActions';
import { ProductSchema } from 'types/products';
import { GameIdSchema, GameSchema, GameStatusSchema } from 'types/games';
import { CompanyDataSchema } from 'stores/CompanyStore/types';
import { callInitData, setActivateApp } from 'utils/window';
import Dispatcher from '../dispatcher/Dispatcher';
import { FormStateAdapter } from './FormActionCreators';
import { addPlayerToTeamOnNode, postPlayerToNode, removePlayerFromTeamOnNode } from './rosterApi';
import FeatureFlagStore from '../stores/FeatureFlagStore/store';
import { FLAGS } from '../stores/FeatureFlagStore/types';
import postGoalToNode from './goalApi';
var baseApiResponseSchema = z.object({
    success: z.boolean()
});
// Static Actions
var closeModalAction = {
    type: ActionTypes.CLOSE_MODAL
};
var showLoaderAction = {
    type: ActionTypes.SHOW_GLOBAL_LOADER
};
var loginAction = { type: ActionTypes.LOGIN };
export var submitScore = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    var apiEndpoint = CompanyStore.getApiEndpoint();
    var config = {
        headers: {
            sbbsession: Cookies.get('sbb_sess')
        }
    };
    axios
        .post("".concat(apiEndpoint, "/api/v1/activities"), data, config)
        .then(function (result) {
        console.log('Activities submitted successfully: ', result);
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    })
        .catch(function () {
        formStateAdapter.triggerFormFailure();
    });
};
var submitProductResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        id: ProductSchema.shape.id
    })
});
export var submitProduct = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    // Strip out id field to avoid sending id: false to backend
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = data, _id = _a.id, productData = __rest(_a, ["id"]);
    API.post('/rest_products', productData, function (error, result) {
        var responseParsingResult = submitProductResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        var product = responseParsingResult.data.data;
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        var addProductAction = {
            type: ActionTypes.ADD_PRODUCT,
            data: __assign(__assign({}, product), { product_name: data.name })
        };
        Dispatcher.dispatch(addProductAction);
    });
};
export var updateProduct = function (data, formId) {
    var id = data.id, product = __rest(data, ["id"]);
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post("/rest_products/".concat(id), product, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var deactivateProduct = function (id, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    var updateProductAction = {
        type: ActionTypes.UPDATE_PRODUCT,
        id: id,
        data: { deactivated: true }
    };
    formStateAdapter.triggerFormLoading();
    Dispatcher.dispatch(updateProductAction);
    API.delete("/rest_products/".concat(id), {}, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (!error &&
            responseParsingResult.success &&
            responseParsingResult.data.success) {
            formStateAdapter.triggerFormSuccess();
            return;
        }
        formStateAdapter.triggerFormFailure();
        var revertProductAction = {
            type: ActionTypes.UPDATE_PRODUCT,
            id: id,
            data: { deactivated: false }
        };
        Dispatcher.dispatch(revertProductAction);
    });
};
export var submitGameProduct = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post('/rest_games/add_product', data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
// We are already calling this endpoint in the 'submitGameProduct' function, can schema be reused?
var secondRestProductsPostResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        id: z.number()
    })
});
export var addNewTrackableToGame = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    var trackableData = {
        name: data.name,
        display_name: '',
        value_required: data.value_required || 0,
        value_label: data.value_label || '',
        memo_required: data.memo_required || 0
    };
    API.post('/rest_products', trackableData, function (error, result) {
        var responseParsingResult = secondRestProductsPostResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        var productId = responseParsingResult.data.data.id;
        var gameData = {
            product_id: productId,
            trackable_mode: data.trackable_mode,
            game_id: data.game_id
        };
        API.post('/rest_games/add_product', gameData, function (innerError, innerResult) {
            var innerResponseParsingResult = baseApiResponseSchema.safeParse(innerResult);
            if (innerError ||
                !innerResponseParsingResult.success ||
                !innerResponseParsingResult.data.success) {
                formStateAdapter.triggerFormFailure();
                return;
            }
            formStateAdapter.triggerFormSuccess();
            Dispatcher.dispatch(closeModalAction);
            Dispatcher.dispatch(showLoaderAction);
        });
    });
};
/**
 * Putting a 'never' type here because when we actually find something using this function, we can
 * create an actual type for the data parameter.
 */
export var updateGameProductOrdering = function (gameId, data) {
    API.post("/rest_games/update_product_ordering/".concat(gameId), data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var addPlayerToGame = function (gameId, playerId) {
    var postData = {
        game_id: gameId,
        player_id: playerId
    };
    API.post('/rest_games/add_player', postData, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var addTeamToGame = function (gameId, teamId, accountId) {
    var postData = {
        game_id: gameId,
        team_id: teamId,
        account_id: accountId
    };
    API.post('/rest_games/add_team', postData, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var submitOrganization = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    var accountId = CompanyStore.getAccountId();
    if (accountId === null) {
        console.error('Account ID not available');
        formStateAdapter.triggerFormFailure();
        return;
    }
    API.post("/rest_accounts/".concat(accountId), data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        // Convert name to account_name for the store
        var name = data.name, storeData = __rest(data, ["name"]);
        if (name) {
            storeData.account_name = name;
        }
        var updateAccountAction = {
            type: ActionTypes.UPDATE_ACCOUNT,
            data: storeData
        };
        Dispatcher.dispatch(updateAccountAction);
    });
};
export var submitPlayer = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    // SCO-552: route the create to the Node endpoint when the flag is on; the
    // legacy PHP path stays the default/fallback (flag off → unchanged).
    // Node is also the only path that can explain a failure: PHP's Cake
    // `isUnique` rule has no `message` key, so a collision came back as the bare
    // literal "isUnique" and the form had nothing truthful to render.
    if (FeatureFlagStore.flag(FLAGS.ROSTER_WRITE_NODE)) {
        postPlayerToNode(data).then(function (result) {
            if (!result.ok) {
                formStateAdapter.triggerFormFailure(result.error);
                return;
            }
            formStateAdapter.triggerFormSuccess();
            Dispatcher.dispatch(closeModalAction);
            Dispatcher.dispatch(showLoaderAction);
        });
        return;
    }
    API.post('/rest_users', data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var updatePlayer = function (data, formId) {
    var id = data.id, rest = __rest(data, ["id"]);
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post("/rest_users/".concat(id), rest, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var updateEmail = function (data, formId) {
    var id = data.id, rest = __rest(data, ["id"]);
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post("/rest_users/updateEmailAddress/".concat(id), rest, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var submitTeam = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post('/rest_teams', data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var updateTeam = function (data, formId) {
    var id = data.id, rest = __rest(data, ["id"]);
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post("/rest_teams/".concat(id), rest, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var addPlayerToTeam = function (teamId, userId) {
    // SCO-559: the PHP endpoint behind this call did its write with the entire
    // ownership ladder commented out. Node runs it.
    if (FeatureFlagStore.flag(FLAGS.ROSTER_WRITE_NODE)) {
        addPlayerToTeamOnNode(teamId, userId).then(function (ok) {
            if (ok) {
                Dispatcher.dispatch(showLoaderAction);
            }
        });
        return;
    }
    API.post("/rest_teams/add_user/".concat(teamId), { user_id: userId }, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var removePlayerFromTeam = function (teamId, userId) {
    // SCO-559 defect 5: the PHP endpoint behind this call never had an ownership
    // ladder written at all — not in the controller, not in the model. Node runs
    // the same guard as add.
    if (FeatureFlagStore.flag(FLAGS.ROSTER_WRITE_NODE)) {
        removePlayerFromTeamOnNode(teamId, userId).then(function (ok) {
            if (ok) {
                Dispatcher.dispatch(showLoaderAction);
            }
        });
        return;
    }
    API.delete("/rest_teams/remove_user/".concat(teamId, "/").concat(userId), {}, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var updateGoal = function (data, formId) {
    var formStateAdapter = formId !== undefined ? new FormStateAdapter(formId) : null;
    formStateAdapter === null || formStateAdapter === void 0 ? void 0 : formStateAdapter.triggerFormLoading();
    var updateGoalAction = {
        type: ActionTypes.UPDATE_GOAL,
        data: data
    };
    Dispatcher.dispatch(updateGoalAction);
    // SCO-359: route the write to the Node endpoint when the flag is on; the
    // legacy PHP path stays as the default/fallback (flag off → unchanged).
    if (FeatureFlagStore.flag(FLAGS.GOAL_WRITE_NODE)) {
        postGoalToNode(data).then(function (ok) {
            if (ok) {
                formStateAdapter === null || formStateAdapter === void 0 ? void 0 : formStateAdapter.triggerFormSuccess();
            }
            else {
                formStateAdapter === null || formStateAdapter === void 0 ? void 0 : formStateAdapter.triggerFormFailure();
            }
        });
        return;
    }
    API.post('/rest_goals', data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter === null || formStateAdapter === void 0 ? void 0 : formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter === null || formStateAdapter === void 0 ? void 0 : formStateAdapter.triggerFormSuccess();
    });
};
export var deactivateTeam = function (id) {
    API.delete("/rest_teams/".concat(id), {}, function () {
        Dispatcher.dispatch(showLoaderAction);
    });
};
var deactivateGameResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        id: GameIdSchema
    })
});
export var deactivateGame = function (id) {
    API.delete("/rest_games/".concat(id), {}, function (error, result) {
        var responseParsingResult = deactivateGameResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        var gameId = responseParsingResult.data.data.id;
        var deleteGameAction = {
            type: ActionTypes.DELETE_GAME,
            data: { id: gameId }
        };
        Dispatcher.dispatch(deleteGameAction);
    });
};
var changeGameAccountStatusResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        game_id: GameIdSchema,
        status: GameStatusSchema
    })
});
export var changeGameAccountStatus = function (data) {
    API.put('/rest_games/update_games_account_status', data, function (error, result) {
        var responseParsingResult = changeGameAccountStatusResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        var responseData = responseParsingResult.data.data;
        var responseGameId = responseData.game_id, responseStatus = responseData.status;
        var changeGameAccountStatusAction = {
            type: ActionTypes.CHANGE_GAME_ACCOUNT_STATUS,
            data: { game_id: responseGameId, status: responseStatus }
        };
        Dispatcher.dispatch(changeGameAccountStatusAction);
    });
};
var removeAccountFromGameResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        id: GameIdSchema
    })
});
export var removeAccountFromGame = function (data) {
    var gameId = data.gameId, accountId = data.accountId, rest = __rest(data, ["gameId", "accountId"]);
    API.post('/rest_games/delete_account', __assign({ game_id: gameId, account_id: accountId }, rest), function (error, result) {
        var responseParsingResult = removeAccountFromGameResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        var responseGameId = responseParsingResult.data.data.id;
        var deleteGameAction = {
            type: ActionTypes.DELETE_GAME,
            data: { id: responseGameId }
        };
        Dispatcher.dispatch(deleteGameAction);
    });
};
export var resendConfirmationEmail = function (userId) { return API.post("/admin/resend_email_confirmation/".concat(userId)); };
export var deactivateUser = function (userId) { return API.post("/admin/deactivate_user/".concat(userId)); };
export var reactivateUser = function (userId) { return API.post("/admin/reactivate_user/".concat(userId)); };
var restGamesResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        game_id: GameIdSchema
    })
});
var gameResponseSchema = baseApiResponseSchema.extend({
    data: GameSchema
});
export var createGame = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post('/rest_games', data, function (error, result) {
        var responseParsingResult = restGamesResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(showLoaderAction);
        var gameId = responseParsingResult.data.data.game_id;
        API.get("/reporting/getStandaloneGame/".concat(gameId), {}, function (err, gameResponse) {
            var gameResult = gameResponseSchema.safeParse(gameResponse);
            if (gameResult.success && gameResult.data.success) {
                Dispatcher.dispatch({
                    type: ActionTypes.FETCH_GAME,
                    data: gameResult.data.data
                });
            }
        });
    });
};
export var removeProductFromGame = function (gameId, productId) {
    var postData = {
        game_id: gameId,
        product_id: productId
    };
    API.post('/rest_games/delete_product', postData, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var updateGameProductGoal = function (gameId, productId, trackMode, goal) {
    var putData = {
        game_id: gameId,
        product_id: productId,
        trackable_mode: trackMode,
        goal: goal
    };
    API.put('/rest_games/edit_product', putData, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var removePlayerFromGame = function (gameId, playerId) {
    API.post('/rest_games/delete_player', {
        game_id: gameId,
        player_id: playerId
    });
};
export var removeTeamFromGame = function (gameId, teamId, accountId) {
    var postData = {
        game_id: gameId,
        team_id: teamId,
        account_id: accountId
    };
    API.post('/rest_games/delete_team', postData);
};
export var submitEditGameForm = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.put("/rest_games/".concat(data.id), { name: data.name }, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        formStateAdapter.triggerFormSuccess();
        Dispatcher.dispatch(closeModalAction);
        Dispatcher.dispatch(showLoaderAction);
    });
};
export var submitEditGameTimes = function (data) {
    var id = data.id, rest = __rest(data, ["id"]);
    API.put("/rest_games/".concat(id), rest, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            return;
        }
        Dispatcher.dispatch(showLoaderAction);
    });
};
/**
 * TODO: Putting 'never' here because I'm not sure what gameMode, whenever we migrate the
 * code that call this fn to typescript, we can create an actual type for the data parameter.
 */
export var setGameMode = function (id, gameMode) {
    API.put("/rest_games/".concat(id), { game_mode: gameMode });
};
/** SCO-726: what PHP answers when a verified code must not open a session. */
var LoginDenialSchema = z.object({
    success: z.literal(false),
    reason: z.enum(['no_account', 'deactivated'])
});
export var login = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post('/admin/ajax_login_with_auth_code', data, function (error, result) {
        var responseParsingResult = CompanyDataSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.account) {
            // SCO-726: a verified code for an address with no active user is a
            // denial, not a sign-up. PHP says why (`no_account` / `deactivated`);
            // carry it into the form state so the screen can say so.
            var denial = LoginDenialSchema.safeParse(result);
            formStateAdapter.triggerFormFailure(denial.success ? denial.data.reason : undefined);
            return;
        }
        // Handle web user login via mobile activation page
        var url = new URL(window.location.href);
        var paramString = url.searchParams;
        if (paramString.has('redirect')) {
            window.location.assign('/');
            return;
        }
        var companyData = responseParsingResult.data;
        var companyDataAction = {
            type: ActionTypes.UPDATE_COMPANY_STORE,
            data: companyData
        };
        Dispatcher.dispatch(companyDataAction);
        Dispatcher.dispatch(loginAction);
        // Begin data syncing
        callInitData(companyData);
        formStateAdapter.triggerFormSuccess();
    });
};
/**
 * Logout for FireTV interface. Data parameter is optional - defaults to empty object.
 */
export var logout = function (data) {
    if (data === void 0) { data = {}; }
    API.post('/api/logout', data, function () { return document.location.replace('/fire'); });
};
/**
 * Logout for mobile interface. Data parameter is optional - defaults to empty object.
 */
export var logoutMobile = function (data) {
    if (data === void 0) { data = {}; }
    API.post('/api/logout', data, function () { return document.location.replace('/mobile'); });
};
var uploadProfilePicResponseSchema = baseApiResponseSchema.extend({
    data: z.object({
        url: z.string()
    })
});
export var uploadProfilePic = function (file, 
// Match expected PHP input
data, formId) {
    var minimumPercentageProgress = 30;
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading(minimumPercentageProgress.toString());
    var endCallback = function (error, result) {
        var responseParsingResult = uploadProfilePicResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure(error);
            return;
        }
        var url = responseParsingResult.data.data.url;
        formStateAdapter.triggerFormSuccess();
        var type = data.upload_type_id === UploadTypes.UPLOAD_TYPE_TEAM ?
            ActionTypes.UPDATE_TEAM :
            ActionTypes.UPDATE_PLAYER;
        /**
         * I have no idea if this is correct.  As far as I can tell upload_url is not a valid field
         * for the update team or player actions. But I'm going to leave it here for now.
         */
        /**
         * Passing id as a string, there is a slight mismatch between init types
         * and the expected store types
         * for the Team ID. Need to align this, update team and update user also handle IDs differently
         */
        Dispatcher.dispatch({
            type: type,
            data: { upload_url: url },
            id: String(data.id)
        });
    };
    var progressCallback = function (progress) {
        var progressString = Math.max(minimumPercentageProgress, progress.percent).toString();
        formStateAdapter.triggerFormLoading(progressString);
    };
    API.upload('/rest_uploads', file, data, endCallback, progressCallback);
};
/**
 * Schema for picker search API responses.
 * Handles arrays of any size (empty, single result, or many results like 10-15 users).
 * Each result contains Account info and optionally User or Team info.
 */
var pickerSearchResponseSchema = baseApiResponseSchema.extend({
    data: z.array(z.object({
        Account: z.object({
            id: z.number(),
            name: z.string()
        }),
        User: z
            .object({
            id: z.number(),
            first_name: z.string().nullable(),
            last_name: z.string().nullable(),
            email: z.string(),
            upload_id: z.number().nullable(),
            upload_url: z.string().optional(),
            name: z.string()
        })
            .optional(),
        Team: z
            .object({
            id: z.number(),
            name: z.string()
        })
            .optional()
    }))
});
export var pickerSearch = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    var endpoint = data.pickerType === PickerTypes.PLAYERS ?
        "/rest_users/search/".concat(data.search) :
        "/rest_teams/search/".concat(data.search);
    API.get(endpoint, {}, function (error, result) {
        var responseParsingResult = pickerSearchResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        var verifiedResult = responseParsingResult.data;
        formStateAdapter.triggerFormSuccess(JSON.stringify(verifiedResult.data));
    });
};
export var validationError = function (formId) {
    new FormStateAdapter(formId).triggerFormValidationFailure();
};
export var setFormToInactive = function (formId) {
    new FormStateAdapter(formId).triggerFormState(FormStateSchema.Enum.INACTIVE);
};
export var addTrackableMapping = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    API.post('/rest_games/add_trackable_mapping', data, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (error ||
            !responseParsingResult.success ||
            !responseParsingResult.data.success) {
            formStateAdapter.triggerFormFailure();
            return;
        }
        var updateGameTrackableMappingAction = {
            type: ActionTypes.UPDATE_GAME_TRACKABLE_MAPPING,
            data: {
                account_id: data.accountId,
                game_id: data.gameId,
                game_product_id: data.game_product_id,
                mapped_product_id: data.mapped_product_id
            }
        };
        Dispatcher.dispatch(updateGameTrackableMappingAction);
        formStateAdapter.triggerFormSuccess();
    });
};
export var dismissNotification = function (data, formId) {
    var formStateAdapter = new FormStateAdapter(formId);
    formStateAdapter.triggerFormLoading();
    var dismissedStatus = NotificationStatusMap.NOTIFICATION_STATUS_DISMISSED;
    var dismissNotificationAction = {
        type: ActionTypes.UPDATE_NOTIFICATION,
        data: {
            id: data.id,
            status: dismissedStatus
        }
    };
    Dispatcher.dispatch(dismissNotificationAction);
    var putData = { status: dismissedStatus };
    API.put("/rest_notifications/edit/".concat(data.id), putData, function (error, result) {
        var responseParsingResult = baseApiResponseSchema.safeParse(result);
        if (!error &&
            responseParsingResult.success &&
            responseParsingResult.data.success) {
            formStateAdapter.triggerFormSuccess();
            return;
        }
        var setUnreadStatusAction = {
            type: ActionTypes.UPDATE_NOTIFICATION,
            data: {
                id: data.id,
                status: NotificationStatusMap.NOTIFICATION_STATUS_UNREAD
            }
        };
        Dispatcher.dispatch(setUnreadStatusAction);
        formStateAdapter.triggerFormFailure();
    });
};
var getGameNotificationSettingsResponseSchema = z.object({
    gameSettings: z.object({
        notificationsDisabled: z.boolean()
    })
});
export var getGameNotificationSettings = function (gameId) {
    var setNotificationsAction = {
        type: ActionTypes.SET_GAME_NOTIFICATIONS,
        data: {
            gameId: gameId,
            loading: true
        }
    };
    Dispatcher.dispatch(setNotificationsAction);
    API.get("/rest_games/get_notifications_preferences/".concat(gameId), {}, function (error, result) {
        var responseParsingResult = getGameNotificationSettingsResponseSchema.safeParse(result);
        if (error || !responseParsingResult.success) {
            return;
        }
        var verifiedResult = responseParsingResult.data;
        if (!error) {
            var notify = !verifiedResult.gameSettings.notificationsDisabled;
            var updateNotificationsAction = {
                type: ActionTypes.SET_GAME_NOTIFICATIONS,
                data: {
                    loading: false,
                    notify: notify,
                    gameId: gameId
                }
            };
            Dispatcher.dispatch(updateNotificationsAction);
        }
    });
};
export var setGameNotificationSettings = function (gameId, notify) {
    var setNotificationsAction = {
        type: ActionTypes.SET_GAME_NOTIFICATIONS,
        data: {
            gameId: gameId,
            loading: true
        }
    };
    Dispatcher.dispatch(setNotificationsAction);
    API.put("/rest_games/set_notifications_preferences/".concat(gameId), { notify: notify }, function (error, result) {
        var responseParsingResult = getGameNotificationSettingsResponseSchema.safeParse(result);
        if (error || !responseParsingResult.success) {
            return;
        }
        var verifiedResult = responseParsingResult.data;
        if (!error) {
            var shouldNotify = !verifiedResult.gameSettings.notificationsDisabled;
            var updateNotificationsAction = {
                type: ActionTypes.SET_GAME_NOTIFICATIONS,
                data: {
                    gameId: gameId,
                    loading: false,
                    notify: shouldNotify
                }
            };
            Dispatcher.dispatch(updateNotificationsAction);
        }
    });
};
export var requestEmailAuthCode = function (data, formId) { return __awaiter(void 0, void 0, void 0, function () {
    var formStateAdapter, apiEndpoint, updateClientStoreAction, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formStateAdapter = new FormStateAdapter(formId);
                apiEndpoint = CompanyStore.getApiEndpoint();
                updateClientStoreAction = {
                    type: ActionTypes.UPDATE_CLIENT_STORE,
                    data: data
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("".concat(apiEndpoint, "/auth/authCode"), data)];
            case 2:
                _a.sent();
                Dispatcher.dispatch(updateClientStoreAction);
                formStateAdapter.triggerFormSuccess();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                formStateAdapter.triggerFormFailure();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
// Activation Code
var activationCodeResponseSchema = z.object({
    activationCode: z.string()
});
export var requestActivationCode = function (formId) { return __awaiter(void 0, void 0, void 0, function () {
    var formStateAdapter, apiEndpoint, response, activationCode, setClientKeyAction, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formStateAdapter = new FormStateAdapter(formId);
                apiEndpoint = CompanyStore.getApiEndpoint();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get("".concat(apiEndpoint, "/auth/activationCode"))];
            case 2:
                response = _a.sent();
                activationCode = activationCodeResponseSchema.parse(response.data).activationCode;
                setClientKeyAction = {
                    type: ActionTypes.SET_CLIENT_KEY,
                    key: 'activationCode',
                    value: activationCode
                };
                Dispatcher.dispatch(setClientKeyAction);
                formStateAdapter.triggerFormSuccess();
                // Start listening to pusher activation channel
                subscribeToActivateAppChannel(activationCode, function (loginData) {
                    console.log('NEED TO TYPE THIS: ', loginData);
                    formStateAdapter.triggerFormLoading();
                    // Login with email and auth code
                    login(loginData, formId);
                });
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                formStateAdapter.triggerFormFailure();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var activateApp = function (activationCode, formId) { return __awaiter(void 0, void 0, void 0, function () {
    var formStateAdapter, apiEndpoint, config, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formStateAdapter = new FormStateAdapter(formId);
                apiEndpoint = CompanyStore.getApiEndpoint();
                config = {
                    headers: {
                        sbbsession: Cookies.get('sbb_sess')
                    }
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("".concat(apiEndpoint, "/auth/activateApp"), { activationCode: activationCode }, config)];
            case 2:
                _a.sent();
                formStateAdapter.triggerFormSuccess();
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                formStateAdapter.triggerFormFailure();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
setActivateApp(activateApp);
// Check if activation code has been activated (for mobile app resume)
var checkActivationResponseSchema = z.object({
    activated: z.boolean(),
    auth_code: z.string().optional(),
    email: z.string().optional()
});
/**
 * Check if the activation code has been used and retrieve credentials
 * Called when the mobile app resumes from background to complete login
 * if the Pusher message was missed while the app was suspended
 */
export var checkActivationStatus = function (activationCode, formId) { return __awaiter(void 0, void 0, void 0, function () {
    var apiEndpoint, response, result, formStateAdapter, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiEndpoint = CompanyStore.getApiEndpoint();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get("".concat(apiEndpoint, "/auth/checkActivation"), { params: { activationCode: activationCode } })];
            case 2:
                response = _a.sent();
                result = checkActivationResponseSchema.parse(response.data);
                if (result.activated && result.auth_code && result.email) {
                    formStateAdapter = new FormStateAdapter(formId);
                    formStateAdapter.triggerFormLoading();
                    login({ auth_code: result.auth_code, email: result.email }, formId);
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            case 3:
                error_4 = _a.sent();
                console.error('Error checking activation status:', error_4);
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
// Stripe billing portal
var restrictedResponseSchema = z.object({
    data: z.string()
});
export var requestStripeCustomerPortal = function (formId) { return __awaiter(void 0, void 0, void 0, function () {
    var formStateAdapter, apiEndpoint, config;
    return __generator(this, function (_a) {
        formStateAdapter = new FormStateAdapter(formId);
        apiEndpoint = CompanyStore.getApiEndpoint();
        config = {
            headers: {
                sbbsession: Cookies.get('sbb_sess')
            }
        };
        axios
            .get("".concat(apiEndpoint, "/restricted"), config)
            .then(function (result) {
            var restrictedresponseParsingResult = restrictedResponseSchema.safeParse(result);
            if (!restrictedresponseParsingResult.success) {
                console.log('Error getting stripe url: ', restrictedresponseParsingResult.error);
                throw restrictedresponseParsingResult.error;
            }
            var stripeCustomerPortalUrl = restrictedresponseParsingResult.data.data;
            var setClientKeyAction = {
                type: ActionTypes.SET_CLIENT_KEY,
                key: ClientKeySchema.Enum.STRIPE_CUSTOMER_PORTAL_URL,
                value: stripeCustomerPortalUrl
            };
            Dispatcher.dispatch(setClientKeyAction);
            formStateAdapter.triggerFormSuccess();
        })
            .catch(function () {
            formStateAdapter.triggerFormFailure();
        });
        return [2 /*return*/];
    });
}); };
// Push notification handlers
export var setUserPushToken = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var apiEndpoint, config;
    return __generator(this, function (_a) {
        apiEndpoint = CompanyStore.getApiEndpoint();
        config = {
            headers: {
                sbbsession: Cookies.get('sbb_sess')
            }
        };
        axios
            .post("".concat(apiEndpoint, "/api/v1/push_tokens"), data, config)
            .then(function (result) {
            console.log(result);
        })
            .catch(function (error) {
            console.log(error);
        });
        return [2 /*return*/];
    });
}); };
export var addUserToKnock = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var apiEndpoint, config;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiEndpoint = CompanyStore.getApiEndpoint();
                config = {
                    headers: {
                        sbbsession: Cookies.get('sbb_sess')
                    }
                };
                return [4 /*yield*/, axios
                        .post("".concat(apiEndpoint, "/api/v1/users/knock"), data, config)
                        .then(function (result) {
                        console.log(result);
                    })
                        .catch(function (error) {
                        console.log(error);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Fetch a signed Knock in-app feed session for the current user (SCO-370/371).
 * Returns null on any failure — notably the endpoint returns 500 until Knock
 * enhanced security + the signing/public keys are configured, so callers must
 * degrade gracefully (no feed) rather than error.
 */
export var getKnockSession = function () { return __awaiter(void 0, void 0, void 0, function () {
    var apiEndpoint, config, result, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiEndpoint = CompanyStore.getApiEndpoint();
                config = {
                    headers: {
                        sbbsession: Cookies.get('sbb_sess')
                    }
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get("".concat(apiEndpoint, "/api/v1/knock/session"), config)];
            case 2:
                result = _a.sent();
                return [2 /*return*/, result.data];
            case 3:
                error_5 = _a.sent();
                console.warn('Knock session unavailable; in-app feed disabled', error_5);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
